import React, { FC, useState } from 'react';
import { Button, ButtonVariant } from 'components/common/buttons/Button';
import { CentsDataGrid } from 'components/common/dataGrid/dataGrid';
import { IndividualPayrocMerchantAccount } from 'api/admin/businesses/getPayrocMerchantAccounts';
import { EditMerchantAccountModal } from './EditMerchantAccountModal';
import styles from './MerchantAccounts.module.scss';
import { usePayrocMerchants } from './queries/usePayrocMerchants';

const COLUMNS = [
  { headerName: 'ID', field: 'id', flex: 1 },
  { headerName: 'Merchant Id', field: 'merchantId', flex: 5 },
];

export const MerchantAccounts: FC<{
  businessId: number;
}> = ({ businessId }) => {
  const { isLoading, data: merchantAccounts, refetch } = usePayrocMerchants(businessId);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [merchant, setMerchant] = useState<IndividualPayrocMerchantAccount | null>(null);

  const handleCreateMerchantAccountClick = () => {
    setMerchant(null);
    setShowEditModal(true);
  };

  const handleRowClick = ({ row }: { row: IndividualPayrocMerchantAccount }) => {
    const { id, merchantId } = row;

    setMerchant({ id, merchantId });
    setShowEditModal(true);
  };

  const handleEditMerchantClose = async (shouldReload: boolean) => {
    if (shouldReload) {
      await refetch();
    }

    setShowEditModal(false);
  };

  return (
    <div className="page-container">
      <div className={styles.header}>
        <Button type={ButtonVariant.CONTAINED} onClick={handleCreateMerchantAccountClick}>
          Add Merchant Account
        </Button>
      </div>
      <CentsDataGrid
        tableName="merchantAccounts"
        data={merchantAccounts}
        columns={COLUMNS}
        onRowClick={handleRowClick}
        isLoading={isLoading}
      />
      {showEditModal && (
        <EditMerchantAccountModal
          businessId={businessId}
          isNew={!merchant}
          merchant={merchant}
          onClose={handleEditMerchantClose}
        />
      )}
    </div>
  );
};
